export enum AiAssistantName {
  POLLY = 'POLLY',
  GRANT_WRITER = 'GRANT_WRITER',
}

export const AiAssistantNameLabel: Record<AiAssistantName, string> = {
  [AiAssistantName.POLLY]: 'Polly, Polco Assistant',
  [AiAssistantName.GRANT_WRITER]: 'Grace, Grant Writing Assistant',
};
